<template>
  <b-modal v-model="show" centered :title="'Auftragsgruppe umbenennen'"
  >
    <b-row class="justify-content-md-center">
      <b-col>
        <label for="name">Name</label>
        <b-form-input id="name" type="text"
                      v-model="name"
                      class="mb-2 text-black"
                      maxlength="50"
                      @focusin="error = false"
                      :state="error ? false : null"
        ></b-form-input>
        <b-form-text style="text-align: right" v-if="!error">{{name.length}}/50</b-form-text>
        <b-form-text style="text-align: right; color: red !important;" v-else>Der Name darf nicht leer sein.</b-form-text>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" variant="success" @click="onSave">
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>

<script>

export default {
  name: "ChangeAugrNameDialog",
  props:{
    augrName: {
      type: String,
      default: () => ""
    },
  },
  data() {
    return {
      show: false,
      name: '',
      error: false,
    }
  },
  methods: {
    showModal() {
     this.name = this.augrName;
      this.error = false;
      this.show = true;
    },
    async onSave() {
      this.name = this.name.trim();
      if (!this.name) {
        this.error = true;
        return;
      }
      this.$emit('change-augr-name', this.name);
      this.show = false;
    },

    onCancel() {
      this.show = false;
    }
  }
}
</script>

<style scoped>
.text-black {
  color: black;
}
.vld-overlay.is-full-page {
  z-index: 1600;
  position: fixed;
}
</style>
